import { buildWebRouteKey } from '@utils/app-message-routes';
import { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';

/**
 * The route pattern a `ProtectedRoute` / `AdminProtectedRoute` was declared with (e.g.
 * `/consignments/edit/:id/:section`), provided by that element. React Router v6 has no
 * `useRouteMatch`, and the router declares its `<Route>` paths with a trailing `/*`, so the
 * pattern the `App_Messages` keys are written against is carried explicitly instead.
 */
export const WebRoutePathContext = createContext<string | undefined>(undefined);

/**
 * The `App_Messages` route key for the screen currently rendered (ENVDB-7836): the declared
 * route's path pattern with `:section` substituted from the URL, `:id` left literal.
 *
 * One hook for both the single mount and the publishing pages, so the two can never compute the
 * key differently — the mount only honours a publication whose route equals its own.
 *
 * Must be called beneath a `ProtectedRoute` / `AdminProtectedRoute`, which supply the pattern;
 * anywhere else the key is `''` and matches no row.
 */
export const useWebRouteKey = (): string => {
    const path = useContext(WebRoutePathContext);
    const { section } = useParams<{ section?: string }>();
    return buildWebRouteKey(path, section);
};

export default useWebRouteKey;
